import React, { useState } from 'react';

const Autocomplete = ({data,setSearchData,showCol}) => {
  const [query, setQuery] = useState('');
  const [filteredOptions, setFilteredOptions] = useState([]);

  const handleChange = (e) => {
    const userInput = e.target.value;
    setQuery(userInput);
    
    if (userInput.length > 0) {
      const filtered = data.filter(option =>
        option[showCol]?.toLowerCase().includes(userInput.toLowerCase())
      );
      setFilteredOptions(filtered);
    } else {
      setFilteredOptions([]);
    }
  };

  const handleSelect = (value) => {
    setQuery(value[showCol]);
    setFilteredOptions([]);
    setSearchData(value)
  };

  return (
    <div className="relative">
    <input
      type="text"
      value={query}
      onChange={handleChange}
      placeholder="Search Data..."
      className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
    {filteredOptions.length > 0 && (
      <ul className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto z-10">
        {filteredOptions.map((option, index) => (
          <li
            key={index}
            onClick={() => handleSelect(option)}
            className="p-2 cursor-pointer hover:bg-blue-100"
          >
            {option[showCol]}
          </li>
        ))}
      </ul>
    )}
  </div>
  );
};

export default Autocomplete;
